import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Front from './Front';
import Back from './Back';
import styles from '../styles';

class index extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { locale, User, UserMemberShip, classes } = this.props;
    return (
      <div>
        <Paper className={classes.CardFront}>
          <Front locale={locale} User={User} UserMemberShip={UserMemberShip} />
        </Paper>
        <Paper className={classes.CardBack}>
          <Back locale={locale} User={User} UserMemberShip={UserMemberShip} />
        </Paper>
      </div>
    );
  }
}

index.propTypes = {
  User: PropTypes.object.isRequired,
  UserMemberShip: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(index);
